import "bootstrap-icons/font/bootstrap-icons.css";
import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { ASSETS_BASE_URL } from "constants";
import { JumbotronBiz } from "sections";

function CommodityFinancing() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Financing"
          title={`
              <div class="break-line-block">
              Commodity&nbsp;<br />
                <span className="jumbotron-subtitle-2">
                 Financing<i>-i</i>
                    </span>
            </div>`}
          buttonText="Reach out to us!"
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              alrajhi bank Malaysia Commodity Financing-<i>i</i> provides
              short-term finance facilities to a range of credit-worthy
              commodity trading companies - from the specialist products trader
              to international trading houses. Combined with our trade
              facilities, you can use the pre-approved credit limit to finance
              your specific business needs. Enjoy too the flexibility of reusing
              the facility repeatedly after each settlement throughout the
              approved period.This product is offered under the concept of Bai'
              Bithaman Ajil.
            </p>
            <p>
              For more information please contact{" "}
              <span style={{ color: "blue" }}>03-2301 7238</span> or{" "}
              <span style={{ color: "blue" }}>03-2301 7166</span>
            </p>
            <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  window.open(
                    `${ASSETS_BASE_URL}assets/pdf/business-financing/PDS+-+Commodity+Financing-i.pdf`
                  )
                }
              />
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default CommodityFinancing;
